import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useRestClient } from '../../../core/api/RestClientContext';
import { SyncFilter, SyncStatus } from '../../../core/models/sync';
import { Button } from '../../../core/components/Button';
import { Card } from '../../../core/components/Card';
import { Input, Label, Select } from '../../../core/components/FormElements';
import './SyncActionsPanel.css';

interface SyncActionsPanelProps {
    className?: string;
}

export const SyncActionsPanel: React.FC<SyncActionsPanelProps> = ({ className = '' }) => {
    const restClient = useRestClient();
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState<SyncStatus | ''>('');
    const [minAttempts, setMinAttempts] = useState<string>('');

    const handleSync = async () => {
        try {
            setLoading(true);

            const filter: SyncFilter = {};
            if (statusFilter) filter.inStatus = [statusFilter];
            if (minAttempts) filter.minAttempts = parseInt(minAttempts, 10);

            await restClient.syncErrors(filter);
            toast.success('Запрос на синхронизацию отправлен');
        } catch (err) {
            console.error(err);
            toast.error('Ошибка отправки запроса');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card className={`sync-actions-panel ${className}`}>
            <h3>Синхронизация</h3>
            <div className="sync-actions-form">
                <div className="form-group">
                    <Label>Статус для пересинхронизации:</Label>
                    <Select
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value as SyncStatus | '')}
                    >
                        <option value="">Все статусы</option>
                        <option value={SyncStatus.FAILED}>FAILED</option>
                        <option value={SyncStatus.PENDING}>PENDING</option>
                        <option value={SyncStatus.SYNCED}>SYNCED</option>
                    </Select>
                </div>

                <div className="form-group">
                    <Label>Мин. кол-во попыток:</Label>
                    <Input
                        type="number"
                        value={minAttempts}
                        onChange={(e) => setMinAttempts(e.target.value)}
                        placeholder="0"
                    />
                </div>

                <div className="form-actions">
                    <Button onClick={handleSync} disabled={loading} className="sync-btn">
                        {loading ? 'Отправка...' : 'Запустить синхронизацию'}
                    </Button>
                </div>
            </div>
        </Card>
    );
};
